import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Receipt, Building2, RefreshCw, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatEuro = (value) => {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value || 0);
};

const AusgabenHistoryTab = ({ onSwitchToManual }) => {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchExpenses = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/ausgaben/recent`, { withCredentials: true });
      setExpenses(response.data || []);
    } catch (error) {
      console.error("Fehler beim Laden der Ausgaben:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchExpenses(); }, []);

  return (
    <div className="space-y-6">
      <div className="bg-slate-800/50 rounded-xl border border-slate-700 p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-white flex items-center gap-2">
            <Receipt className="text-amber-400" />
            Letzte Ausgaben
          </h2>
          <Button size="sm" variant="outline" onClick={fetchExpenses} className="border-slate-600">
            <RefreshCw size={14} className={loading ? 'animate-spin' : ''} />
          </Button>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="animate-spin text-slate-400" size={24} />
          </div>
        ) : expenses.length > 0 ? (
          <div className="space-y-3">
            {expenses.map((expense, idx) => (
              <div key={idx} className="flex items-center justify-between p-4 bg-slate-700/50 rounded-lg">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-red-500/20 rounded-lg">
                    <Building2 size={18} className="text-red-400" />
                  </div>
                  <div>
                    <p className="text-white font-medium">{expense.lieferant}</p>
                    <p className="text-sm text-slate-400">
                      {expense.datum} | {expense.kategorie} | {expense.positionen_count || 0} Positionen
                    </p>
                  </div>
                </div>
                <span className="text-lg font-mono text-red-400">{formatEuro(expense.gesamtbetrag)}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-slate-500">
            <Receipt size={40} className="mx-auto mb-3 opacity-30" />
            <p>Noch keine Ausgaben erfasst</p>
            <Button onClick={onSwitchToManual} className="mt-4 bg-violet-600">
              Erste Ausgabe erfassen
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AusgabenHistoryTab;
